export default __webpack_public_path__ + "static/media/videoLayoutIcon.8d6eb16d.svg";